<!--
   Created by qing on 2021/7/28
   Des:
-->
<template>

  <div class="page-loading-container">
    <vue-loaders-ball-scale-multiple color="#4A66FA" scale="1"></vue-loaders-ball-scale-multiple>
    <div class="tips">加载中...</div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        appId: '',
        formId: '',
        viewId: '',
        stepId: '',
        instanceId: '',
        recordId: '',
        btnId: ''
      }
    },
    async created() {

      this.$store.commit('SET_YMT_NODEKEY', this.$route.query.key)
      this.$store.commit('SET_LOGIN_DRAGGABLE', false)
      await this.$store.dispatch('actionWechatNodeGet', this.$route.query.key)
        .then(res => {
          if(res.env) this.$store.commit('UPDATE_ENV', res.env)
          if(res.openId) this.$store.commit('UPDATE_OPENID', res.openId)
          if(res.qrcode) this.$store.commit('SET_YMT_QRCODE', res.qrcode)

          this.appId = res.appId
          this.formId = res.formId
          this.viewId = res.viewId
          this.stepId = res.stepId
          this.instanceId = res.instanceId
          this.recordId = res.recordId
          this.showLoginButton = res.showLoginButton
          this.btnId = res.btnId
          this.$store.commit('SET_LOGIN_DRAGGABLE', this.showLoginButton === 'YES')
        })
        .catch(err => {
          console.error(err)
        })

      if (!this.$store.getters.userId) {

        await this.$store.dispatch('actionGuestTokenGet', {
          expireAfter: 0
        }).catch(console.error)
      }

      if (this.viewId) {

        this.$store.dispatch('actionNodeSave', {
          instanceId: this.instanceId,
          stepId: this.stepId,
          viewId: this.viewId,
          showFields: [],
          appId: this.appId,
          formId: this.formId,
          btnId: this.btnId,
          dataList: []
        }).then(res => {
          return this.$store.dispatch('actionNodeSave', {
            appId: this.appId,
            formId: this.formId,
            to: `${location.origin}${this.$MINIAPP_BASE_PATH}/#/formViewDataDetail?key=${res.nodeKey}`
          })
        }).then(res => {
          location.replace(`${location.origin}${this.$MINIAPP_BASE_PATH}/#/3rd_router?key=${res.nodeKey}`)
        }).catch(err => {
          console.error(err)
        })

      } else {

        this.$store.dispatch('actionNodeSave', {
          instanceId: this.instanceId,
          showFields: [],
          appId: this.appId,
          formId: this.formId,
          dataList: []
        }).then(res => {
          return this.$store.dispatch('actionNodeSave', {
            appId: this.appId,
            formId: this.formId,
            to: `${location.origin}${this.$MINIAPP_BASE_PATH}/#/formDataDetail?key=${res.nodeKey}`
          })
        }).then(res => {
          location.replace(`${location.origin}${this.$MINIAPP_BASE_PATH}/#/3rd_router?key=${res.nodeKey}`)
        }).catch(err => {
          console.error(err)
        })
      }
    },
    methods: {}
  }
</script>

<style lang="less">

  .page-loading-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .tips {
      margin-top: 20px;
      color: #4A66FA;
    }
  }
</style>
